import React from 'react';
import CustomModal from './CustomModal';

const RecurrenceEditModal = ({ isOpen, onClose, onConfirm, appointment }) => {
  const handleConfirm = (scope) => {
    onConfirm(scope);
    onClose();
  };

  if (!isOpen || !appointment) return null;

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title="Modification d'un rendez-vous récurrent"
    >
      <div className="space-y-4">
        <p className="text-gray-700">
          Ce rendez-vous fait partie d'une série récurrente. Souhaitez-vous appliquer cette modification :
        </p>
        
        <div className="space-y-2">
          <button
            onClick={() => handleConfirm('this')}
            className="w-full p-3 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Seulement à ce rendez-vous
          </button>
          
          <button
            onClick={() => handleConfirm('future')}
            className="w-full p-3 bg-green-500 text-white rounded hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            À toute la série à partir de ce rendez-vous
          </button>
        </div>
        
        <button
          onClick={onClose}
          className="w-full p-3 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
        >
          Annuler
        </button>
      </div>
    </CustomModal>
  );
};

export default RecurrenceEditModal;
